<template>
	<div class="Grpfoot w100 pb-28">
		<div class="w1500">
			<div class="box flex j-between mb-93">
				<div class="f-menu f-menus" v-for="(f, i) in footdaohan">
					<div class="tit-19  B-400 mt-61 mb-20 montserRegular" style="color:#fff !important">{{ f.name }}</div>
					<div class="ys-33 B-300" v-for="(g, i) in f.footer" @click="qudakai(g.url)" style="color:#BBBBBB !important">{{ g.name }}</div>
				</div>
				<!-- <div class="f-menu f-menus" >
					<div class="tit-19 ys-33 B-400 mt-61 mb-20 montserRegular">Forum</div>
					<div class="ys-33 B-300" v-for="(g,i) in groupLie"  @click="$dakai('group?id='+g.id)">{{g.groupName}}</div>
				</div> -->
				<!-- <div class="f-menu f-menus">
					<div class="tit-19 ys-33 B-400 mt-61 mb-20 montserRegular">Resource</div>
					<div class="ys-33 B-300" @click="foottiao('/video',1,0)">Video</div>
					<div class="ys-33 B-300" @click="foottiao('/blog',1,1)">Blog</div>
					<div class="ys-33 B-300" @click="foottiao('/webinar',1,2)">webinar</div>
				</div>
				<div class="f-menu f-menus">
					<div class="tit-19 ys-33 B-400 mt-61 mb-20 montserRegular">GoodWe Plus+</div>
					<div class="ys-33 B-300" v-if="wodeshu.country">{{wodeshu.country}}</div>
				</div>
				<div class="f-menu f-menus">
					<div class="tit-19 ys-33 B-400 mt-61 mb-20 montserRegular">Company</div>
					<div class="ys-33 B-300">Offical website</div>
					<div class="ys-33 B-300">Download</div>
					<div class="ys-33 B-300"> Online support</div>
					<div class="ys-33 B-300">Contact us</div>
					<div class="ys-33 B-300">Warranty</div>
				</div>
				<div class="f-menu f-menus">
					<div class="tit-19 ys-33 B-400 mt-61 mb-20 montserRegular">Service</div>
					<div class="ys-33 B-300">SEMS PortalEz</div>
					<div class="ys-33 B-300">Designer</div>
				</div> -->
				<div class="f-menu">
					<div class="tit-19 ys-33 B-400 mt-61 mb-20 montserRegular">Follow Us</div>
					<div class="flex  youtu-face">
						<img :src="require('@/assets/youtube.png')" @click="tiaowai(1)" class="mr-14" style="width:.36rem;height:.36rem;">
						<img :src="require('@/assets/facebook.png')" @click="tiaowai(2)" class="" style="width:.36rem;height:.36rem;">
					</div>
				</div>
			</div>

			<!-- 手机端底部导航 -->
			<div class="wrapBox">
				<el-collapse accordion>
					<el-collapse-item class="item" v-for="(f, i) in footdaohan">
						<template slot="title">
							<div class="tit tit-20">{{ f.name }}</div>
						</template>
						<ul>
							<li class="tit-16" v-for="(g, i) in f.footer" @click="qudakai(g.url)">{{ g.name }}</li>
							<!-- <li class="tit-16"  @click="foottiao('/webinar')">webinar</li>
							<li class="tit-16"  @click="foottiao('/video')">Video</li> -->
						</ul>
					</el-collapse-item>
					<!-- <el-collapse-item class="item">
						<template slot="title">
							<div class="tit tit-20">Resource</div>
						</template>
						<ul>
							<li class="tit-16"  @click="foottiao('/blog')" >Blog</li>
							<li class="tit-16"  @click="foottiao('/webinar')">webinar</li>
							<li class="tit-16"  @click="foottiao('/video')">Video</li>
						</ul>
					</el-collapse-item>
					<el-collapse-item class="item">
						<template slot="title">
							<div class="tit tit-20">GoodWe Plus+</div>
						</template>
						<ul>
							<li class="tit-16"v-if="wodeshu.country">{{wodeshu.country}}</li>
						</ul>
					</el-collapse-item>
					<el-collapse-item class="item">
						<template slot="title">
							<div class="tit tit-20">Company</div>
						</template>
						<ul>
							<li class="tit-16">Offical website</li>
							<li class="tit-16">Download</li>
							<li class="tit-16">Online support</li>
							<li class="tit-16">Contact us</li>
							<li class="tit-16">Warranty</li>
						</ul>
					</el-collapse-item>
					<el-collapse-item class="item">
						<template slot="title">
							<div class="tit tit-20">Service</div>
						</template>
						<ul>
							<li class="tit-16">SEMS Portal</li>
							<li class="tit-16">EzDesigner</li>
						</ul>
					</el-collapse-item> -->
				</el-collapse>

				<div class="flow">
					<div class="tit">Follow Us</div>
					<dl>
						<dd>
							<img @click="tiaowai(1)" :src="require('@/assets/youtube.png')">
						</dd>
						<dd>
							<img @click="tiaowai(2)" :src="require('@/assets/facebook.png')">
						</dd>
					</dl>
				</div>
			</div>


			<div class="flex f-menu-xinxi">
				<div class="" style="color: #b9b9b9;">Copyright © 2021 GoodWe Technologies Co.,Ltd</div>
				<div class="ml-63  mr-63" style="color: #b9b9b9;">Contact us:academy@goodwe.com</div>
				<div class=" cur_pointer" style="color: #b9b9b9;"> <i @click="foottiao2('/userAgreement')">Terms of use</i> <i
						class="ml-20 mr-20">|</i> <i @click="foottiao2('/privateAgreement')"> Privacy Policy</i> </div>
			</div>
		</div>
		<BackTop></BackTop>
<!-- v-if="!consentGiven" -->
		<!-- <div class="he_cook" v-if="!consentGiven">
			<div class="w1500">
				<div class="he_cookc">
					<div class="info">
						<div class="p1">This website uses cookies</div>
						<div class="text">
							We use cookies to personalise content and ads, to provide social
							medla features and to analvse our trafic. Wwe also share
							information alboutyour use of our site with our social media,
							advertising and analytics partners who may combine it with other
							information that you've providedto them or that they've collected
							from your use of their services.
						</div>
					</div>
					<div class="he_cookmo">
						<div class="he_cooknb he_cooknb2">
							<div class="he_syp2mob">
								<a href="javascript:;" class="getCookie" @click="acceptCookies">Allow all</a>
							</div>
						</div>
						<div class="he_cooknb he_cooknb1">
							<div class="he_syp2mob">
								<a href="javascript:;" @click="rejectCookies">Deny</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div> -->
		<div class="he_cook" v-if="!consentGiven">
			<div class="he_cook_box">
				<div class="info">
					<div class="p1">This website uses cookies</div>
					<div class="text">
						We use cookies to personalise content and ads, to provide social
						medla features and to analvse our trafic. Wwe also share
						information alboutyour use of our site with our social media,
						advertising and analytics partners who may combine it with other
						information that you've providedto them or that they've collected
						from your use of their services.
					</div>
					<div class="more_info" @click="foottiao2('/privateAgreement')">
						<span style="font-weight: bold;">More info</span>
					</div>
				</div>
				
					
				<div class="he_cookc">
					<div class="he_cooknb he_cooknb1"  @click="onCustomize">
						<a href="javascript:;" class="getCookie">Customize</a>
					</div>
					<div class="he_cookmo" style="display: flex;">
						<div class="he_cooknb he_cooknb2" @click="acceptCookies">
							<a href="javascript:;" class="getCookie" >Allow all</a>
						</div>
						<div class="he_cooknb he_cooknb2" @click="rejectCookies">
							<a href="javascript:;" >Deny</a>
						</div>
					</div>
				</div>
			</div>
		</div>
		<el-dialog title="Cookie preferences" class="cookebox" :visible.sync="dialogFormVisible">
			<div style="color: #ffffff;margin-bottom: 10px;">Cookie usage</div>
			<div style="color: #ffffff;margin-bottom: 10px;">GoodWe is using cookies to improve your user experience. By clicking ‘Accept all’ you consent that we can access, collect, store and use cookies and your IP address in accordance with our Cookie Policy</div>
		 
			<div class="xuanzz" style="display: flex;align-items: center;">
				<div @click="show1 =! show1" :class="show1==true?'rotateBottom':''" style="background: #d5dee2;border-radius: 50%;color: #2c2f31;font-weight: bold;box-sizing: border-box;font-size: 13px;width: 20px;height: 20px;display: flex;align-items: center;justify-content: center;"><span class="el-icon-arrow-down" style="font-size: 13px;"></span></div>
				<div class="" style="flex: 1;color: #fff;margin-left: 10px;" @click="show1 =! show1">Necessary</div>
				<el-switch disabled v-model="value1" active-color="#ff4949"> </el-switch>
			</div>

			<div v-if="show1" style="border: 1px solid #dee4e9;color: #ffffff;border-top: none;padding: 14px;">Necessary cookies help make a website usable by enabling basic functions like page navigation and access to secure areas of the website. The website cannot function properly without these cookies.</div>
			
			<div class="xuanzz" style="display: flex;align-items: center;margin-top: 5px;">
				<div @click="show2 =! show2" :class="show2==true?'rotateBottom':''" style="background: #d5dee2;border-radius: 50%;color: #2c2f31;font-weight: bold;box-sizing: border-box;font-size: 13px;width: 20px;height: 20px;display: flex;align-items: center;justify-content: center;"><span class="el-icon-arrow-down" style="font-size: 13px;"></span></div>
				<div class="" style="flex: 1;color: #fff;margin-left: 10px;" @click="show2 =! show2">Performance and analytics</div>
				<el-switch v-model="value2" active-color="#ff4949"> </el-switch>
			</div>
			<div v-if="show2" style="border: 1px solid #dee4e9;color: #ffffff;border-top: none;padding: 14px;">Performance cookies are used to understand and analyze the key performance indexes of the website which helps in delivering a better user experience for the visitors. Analytical cookies are used to understand how visitors interact with the website. These cookies help provide information on metrics such as the number of visitors, bounce rate, traffic source, etc.</div>
			<div v-if="show2" style="border: 1px solid #dee4e9;color: #ffffff;border-top: none;padding: 14px;">
				<div>Cookie table</div>
				<div style="display: flex;padding: 8px 0;color: #ffffff;font-weight: bold;">
					<div style="width: 20%">Cookie</div>
					<div style="width: 30%">Domain</div>
					<div style="width: 50%">Description</div>
				</div>
				<div class="xiaoguo" style="display: flex;padding: 8px 0;color: #ffffff;">
					<div style="width: 20%">_ga</div>
					<div style="width: 30%">goodwe.com</div>
					<div style="width: 50%">Identify user access</div>
				</div>
				<div class="xiaoguo" style="display: flex;padding: 8px 0;color: #ffffff;">
					<div style="width: 20%">_gid</div>
					<div style="width: 30%">goodwe.com</div>
					<div style="width: 50%">Differentiate user access sessions</div>
				</div>
			</div>
			
			<div class="xuanzz" style="display: flex;align-items: center;margin-top: 5px;">
				<div  @click="show3 =! show3" :class="show3==true?'rotateBottom':''" style="background: #d5dee2;border-radius: 50%;color: #2c2f31;font-weight: bold;box-sizing: border-box;font-size: 13px;width: 20px;height: 20px;display: flex;align-items: center;justify-content: center;"><span class="el-icon-arrow-down" style="font-size: 13px;"></span></div>
				<div class="" style="flex: 1;color: #fff;margin-left: 10px;" @click="show3 =! show3">Marketing</div>
				<el-switch v-model="value3" active-color="#ff4949"> </el-switch>
			</div>
			<div v-if="show3" style="border: 1px solid #dee4e9;color: #ffffff;border-top: none;padding: 14px;">Marketing cookies are used to provide visitors with customized advertisements based on the pages you visited previously and to analyze the effectiveness of the ad campaigns.</div>
			<div class="xiaoguo2" style="padding: 16px;color: #ffffff;margin-top: 20px;border: 1px solid transparent;border-radius: 3px;">
				<div style="font-weight: bold;margin-bottom: 8px;">More information</div>
				<div>For any queries in relation to our policy on cookies and your choices, please <i class="lianhoce" @click="tiaowai(5)"> contact us.</i></div>
			</div>
		  
		  <div slot="footer" class="dialog-footer" style="display: flex;justify-content: space-between;">
		    <el-button round type="danger" @click="baocun" style="background: linear-gradient(to left, #E60012, #FF7759) !important;">Save Choices</el-button>
		    <div class="btn2">
				<el-button round type="danger" @click="rejectCookies" style="background: linear-gradient(to left, #E60012, #FF7759) !important;">Reject All</el-button>
				<el-button round type="danger" @click="acceptCookies" style="background: linear-gradient(to left, #E60012, #FF7759) !important;">Accept All</el-button>
			</div>
		  </div>
		</el-dialog>
		<!-- <div class="tanchuang">
			<div class="neirong">
				<div class="neirong_top" style="display: flex;justify-content: space-between;align-items: center;">
					<div class="pm__title" id="pm__title" style="font-weight: bold;">Cookie preferences</div>
					<span class="tubb iconfont icon-guanbi2"></span>
				</div>
				<div>Cookie usage</div>
				<div>GoodWe is using cookies to improve your user experience. By clicking ‘Accept all’ you consent that we can access, collect, store and use cookies and your IP address in accordance with our Cookie Policy</div>
				<div>
					<div>
						
					</div>
				</div>
			</div>
		</div> -->
	</div>
</template>

<script>
import { groupList } from '@/api/group.js';
import { allUser } from '@/api/user.js';
import { dibudaohan } from '@/api/index.js';

export default {
	data() {
		return {
			groupLie: [],
			wodeshu: {},
			footdaohan: [],
			consentGiven: false,
			dialogFormVisible: false,
			show1: false,
			show2: false,
			show3: false,
			value1: true,
			value2: false,
			value3: false,
		}
	},
	mounted() {
		this.checkCookieConsent();
	},
	created() {
		groupList().then(shu => {
			this.groupLie = shu.data
		})
		// allUser().then(s => {
		// 	if(s.code==200){
		// 		this.wodeshu=s.data
		// 	}
		// })
		dibudaohan().then(s => {
			this.footdaohan = s.data.footer
		})
	},
	methods: {
		baocun() {
			this.$cun('Performance',this.value2)
			this.$cun('Marketing',this.value3)
			this.dialogFormVisible = false
			this.consentGiven = false;
		},
		onCustomize() {
			this.dialogFormVisible = true
		},
		foottiao(e, Tindex, Mindex) {
			this.$dakai(e)
			this.$cun('Tindex', Tindex)
			this.$cun('Menuindex', Mindex)
		},
		qudakai(e) {
			window.open(e);
		},
		foottiao2(e) {
			var urls = 'https://community.goodwe.com' + e
			window.open(urls);
		},
		tiaowai(e){
			if(e==1){
				window.open('https://www.youtube.com/c/GoodWeSolarAcademy');
			}else if(e==5){
				window.open('https://emea.goodwe.com/contact-us');
			}else{
				window.open('https://www.facebook.com/GoodWeSolarAcademy');
			}
		},
		// 以下为Cookie代码
		checkCookieConsent() {
			const consent = this.getCookie("cookie_consent");
			this.consentGiven = consent !== null;
		},
		acceptCookies() {
			this.setCookie("cookie_consent", "accepted", 30);
			this.consentGiven = true;
			this.dialogFormVisible = false
		},
		rejectCookies() {
			this.setCookie("cookie_consent", "rejected", 30);
			this.consentGiven = true;
			this.dialogFormVisible = false
		},
		setCookie(name, value, days) {
			const date = new Date();
			date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
			const expires = "expires=" + date.toUTCString();
			document.cookie = `${name}=${encodeURIComponent(
				value
			)}; ${expires}; path=/; Secure; SameSite=Lax`;
		},
		getCookie(name) {
			const nameEQ = name + "=";
			const cookies = document.cookie.split(";");
			for (let i = 0; i < cookies.length; i++) {
				let cookie = cookies[i];
				while (cookie.charAt(0) === " ") {
					cookie = cookie.substring(1);
				}
				if (cookie.indexOf(nameEQ) === 0) {
					return decodeURIComponent(cookie.substring(nameEQ.length));
				}
			}
			return null;
		}
	}
}
</script>

<style lang="scss">
.ysE71018 {
	color: #E71018;
}

.ys666 {
	color: #666;
}
.lianhoce:hover{
		color:red;
		cursor: pointer
	}
	.cookebox .el-dialog{
		background: #2A2A2D;
	}
.el-dialog {
	// background: #2A2A2D;
	.el-dialog__title {color: #fff;font-weight: bold;}
	.xuanzz {
		border: 1px solid #f0f4f7;border-radius: 3px;padding: 16px;
	}
	.xuanzz:hover {
	    background: linear-gradient(to left, #E60012, #FF7759) !important;
	    border-color: var(--cc-cookie-category-block-hover-border) !important;
	}
	.rotateBottom {
		transform: rotate(-180deg);
	  }
	.xiaoguo:hover { background: #888; }
	.xiaoguo2:hover {
	    border: 1px solid #f0f4f7 !important;
	}
	.el-button.is-round {
	    border-radius: 25px;
	    padding: 12px 23px;
		}
}
.tanchuang {
	position: fixed;top: 10%;width: 100%;z-index: 999;
	.neirong {
		height: 600px;border-radius: 5px;width: 688px;background: #2A2A2D;margin: 0 auto;
		.neirong_top {
			padding: 10px 22px;color: #fff;font-size: 16px;
			.tubb {font-size: 40px;color: #ddd;}
		}
	}
}

.Grpfoot {
	background: #404040;

	// height:4.44rem;
	.f-menus {
		div:not(:first-child) {
			line-height: 34px;
			color: #666;
		}
	}

	.f-menu {
		div {
			cursor: pointer;
		}

		>div:hover {
			color: #E71018;
		}

		.youtu-face div {
			font-size: 24px;
		}

	}

	.f-menu-xinxi {
		div {}

	}
}

/* cookies */
.he_cook {position: fixed; z-index: 998; bottom: 0; width: 100%; background: #2A2A2D; padding: .1rem 0 .2rem;box-shadow: .1rem .1rem .1rem rgba(0, 0, 0, 1);color: #fff;}
.he_cook .info {padding: .3rem .1rem 0 .1rem;}
.he_cook .info .p1 {color: #fff; font-size: var(--font22);font-weight: 700;padding:  0 .13rem;}
.he_cook .info .text {margin-top: .12rem;color: #fff;font-size: var(--font16);padding: 0 .13rem .11rem .13rem;}
.he_cook .info .more_info  {
	
	padding:  .1rem .13rem;
	font-size: .12rem !important;
	line-height: 1.5 !important; 
	
	    font-weight: 600;
		span {color: red;	transition: background-size .25s, color .25s ease;
	background-image: linear-gradient(currentColor, currentColor);
	    background-position: 0 100%;
	    background-repeat: no-repeat;
		cursor: pointer;
	    background-size: 0 1px;}
}
.he_cook .info .more_info span:hover {
    background-size: 100% 1px;color: red!important
    
}
.he_cook .he_cookc {padding: .1rem .13rem;display: flex;justify-content: space-between;}
.he_cook .he_cooknb a {
	text-decoration:none;
}
.he_cook .he_cooknb1 {
		cursor: pointer;
		background: #ddd;
		border-color: #ddd;
		font-size: var(--font18);
		display: flex;
		align-items: center;
		justify-content: center;
		height: .45rem;
		min-height: 36px;
		border-radius: 30px;
		width: auto;
		padding: 0 .2rem;
		text-align: center;
		a {color: #2c2f31;}
	}
	.he_cook .he_cooknb2 {
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 1.75rem;
		right: 2.25rem;
		background: linear-gradient(to left, #E60012, #FF7759);
		height: .45rem;
		min-height: 36px;
		font-size: var(--font18);
		margin-left: .4rem;
		text-align: center;
		border-radius: 30px;
		min-width: 120px;
	    padding-left: .2rem;
	    padding-right: .2rem;
		a {color: #ffffff;}
	}
.he_cook .he_cooknb a:hover {
	
}
// .he_cook {position: fixed; z-index: 9; bottom: 0; width: 100%; background: #2A2A2D; padding: .5rem 0;box-shadow: .1rem .1rem .1rem rgba(0, 0, 0, 1);color: #fff;}
// .he_cook .he_cookc {display: flex; justify-content: space-between;align-items: center;}
// .he_cook .info {width: 65%;}
// .he_cook .info .p1 {color: #fff; font-size: var(--font26);font-weight: 700;}
// .he_cook .info .text {margin-top: .2rem;color: #fff;}
// .he_cook .he_cooknb a {display: block; border: 2px solid #ff0013;color: #ff0013;font-weight: 700; padding: .13rem 1rem; box-sizing: border-box; transition: .5s;}
// .he_cook .he_cooknb.he_cooknb1 {margin-top: .15rem;}
// .he_cook .he_cooknb a:hover {background: #ff0013; color: #fff;}

// ==========================================================================================================================================================================
// 响应式
// 手机端导航
.Grpfoot .wrapBox {
	display: none;
	padding: .3rem 0;
}

.Grpfoot .wrapBox .item ul li {
	margin: .15rem 0;
}

.Grpfoot .wrapBox .flow {
	margin-top: .5rem;
}

.Grpfoot .wrapBox .flow dl {
	display: flex;
	margin-top: .3rem;
}

.Grpfoot .wrapBox .flow dl dd {
	width: 10%;
	margin-right: .5rem;
}

.Grpfoot .wrapBox .flow dl dd img {
	max-width: 100%;
}

@media screen and (max-width: 767px) {
	.Grpfoot .wrapBox {
		display: block;
	}

	.Grpfoot .box {
		display: none;
	}


	/* cookies */
	.he_cook .he_cook_box {width: 88%;}
	.he_cook .he_cookc {flex-wrap: wrap;}
	.he_cook .info {width: 100%;}
	.he_cookmo {width: 100%; display: flex; justify-content: center; margin-top: .3rem;}
	.he_cook .he_cooknb {margin: 0 .2rem;}
	.he_cook .he_cooknb.he_cooknb1 {margin-top: 0;}

	.cookebox .el-dialog {width: 100%; margin: 0 !important;}
	.cookebox  .el-dialog__footer{padding: 10px 0px 20px 10px;}
	.cookebox .dialog-footer {flex-wrap: wrap;}
	.cookebox .dialog-footer .btn2 {}
	.cookebox .dialog-footer .btn2 button {margin: 0; margin-right: .25rem;}
	.cookebox .el-dialog .el-button.is-round {padding: 12px 15px;}
}
</style>